import { render, staticRenderFns } from "./MemberForm.vue?vue&type=template&id=d1d71904"
import script from "./MemberForm.vue?vue&type=script&lang=ts"
export * from "./MemberForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports